export default import.meta.ROLLDOWN_FILE_URL_OPZWftboYm6TL9jNDM15Jw